import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";

const STEPS = [
  {
    no: "01",
    title: "Dialog statt Formular",
    body: "Sie beantworten 15 Fragen aus Ihrem ganz normalen Arbeitsalltag – ruhig, ohne Fachbegriffe, eine nach der anderen.",
  },
  {
    no: "02",
    title: "Fünf Handlungsfelder als Karte",
    body: "Aus Ihren Antworten entstehen fünf Handlungsfelder: Zeitfresser, Wissenssicherung, wiederkehrende Aufgaben, Entlastungspotenziale und Handlungsfähigkeit.",
  },
  {
    no: "03",
    title: "Individuelle Einordnung",
    body: "Sie erhalten einen schriftlichen Kurzbericht. Klar formuliert. Auf Ihre Antworten zugeschnitten. Keine Tool-Marketing-Sprache.",
  },
  {
    no: "04",
    title: "Konkreter Pilot",
    body: "Wir schlagen Ihnen einen schlanken 14-Tage-Pilot vor – für genau eine Aufgabe. Erst dann beginnt die eigentliche Arbeit.",
  },
];

export default function Methode() {
  return (
    <div data-testid="methode-page">
      <section className="border-b border-[hsl(var(--border))] bg-white">
        <div className="kk-container py-20 lg:py-28 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="kk-overline mb-5">Die Methode</div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[var(--kk-anthracite)]">
              Aus über zehn Jahren Praxis – nicht aus einem Lehrbuch.
            </h1>
            <p className="mt-8 text-lg text-[var(--kk-anthracite)]/75 leading-relaxed max-w-2xl">
              Der KI-Kompass ist kein Software-Produkt. Er ist die digitale
              Form einer Beratungs- und Workshop-Methode, die seit Jahren in
              Kommunen, Stadtwerken und mittelständischen Betrieben angewendet
              wird. Das Ziel ist immer das gleiche: Menschen zurück zu der
              Arbeit bringen, die nur sie selbst tun können.
            </p>
          </div>
          <div className="lg:col-span-5 flex justify-center items-center">
            <div className="relative w-56 h-56 sm:w-72 sm:h-72 border border-[hsl(var(--border))] kk-crosshair flex items-center justify-center">
              <Compass className="w-16 h-16 text-[var(--kk-bluegreen)]" strokeWidth={1} />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[var(--kk-offwhite)]">
        <div className="kk-container py-20 lg:py-24">
          <div className="kk-overline mb-3">So funktioniert es</div>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-[var(--kk-anthracite)] mb-14 max-w-3xl">
            Vier ruhige Schritte zu einer klaren Einschätzung.
          </h2>
          <div className="grid md:grid-cols-2 gap-px bg-[hsl(var(--border))]">
            {STEPS.map((s) => (
              <div key={s.no} className="bg-white p-8 lg:p-10" data-testid={`step-${s.no}`}>
                <div className="flex items-baseline gap-4">
                  <span className="kk-numeric text-3xl text-[var(--kk-bluegreen)]/40">{s.no}</span>
                  <h3 className="text-xl font-semibold tracking-tight text-[var(--kk-anthracite)]">
                    {s.title}
                  </h3>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-[var(--kk-anthracite)]/70">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[hsl(var(--border))]">
        <div className="kk-container py-20 lg:py-24 max-w-3xl">
          <div className="kk-overline mb-4">Haltung</div>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-[var(--kk-anthracite)]">
            Der Mensch entscheidet. Immer.
          </h2>
          <div className="mt-10 space-y-6 text-base text-[var(--kk-anthracite)]/75 leading-relaxed">
            <p>
              Wir glauben nicht, dass jede Organisation mit einer großen
              Digitalisierungswelle beginnen muss. Die meisten Wirkungen
              entstehen in einem klar abgegrenzten Anwendungsfall – einer
              einzigen Aufgabe, die nachweislich entlastet.
            </p>
            <p>
              Deshalb mündet der KI-Kompass in einem Pilotvorschlag, nicht in
              einem 80-seitigen Konzept. Wir nehmen Datenschutz, eigene
              Umgebungen und die Sorgen der Mitarbeitenden ernst – weil das
              die Grundlage jeder belastbaren Lösung ist.
            </p>
          </div>
          <Link to="/kompass" className="kk-btn-primary mt-12" data-testid="methode-cta-btn">
            Kompass starten
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
